// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","130":"d98b4e85","202":"a260f369","406":"668f46cc","491":"78b2993e","762":"212d9b70","935":"dc8a1191"}[chunkId] + ".chunk.js";
};